import * as FC from "@fluentui/react-components";
import {
    equipmentMaintenanceStateDisplay,
    equipmentOperationalStatusDisplay,
    equipmentWarrantyStateDisplay,
} from "../../services/equipment_service";

// Colour is only an aid; the text label is always rendered (design 8.2).
// red = 逾期/过期, orange = 即将到期, green = 正常/有效, grey = 未设置.
const badgeColors = {
    operationalStatus: {
        available: "success",
        in_use: "informative",
        under_service: "warning",
        out_of_service: "severe",
        retired: "subtle",
        scrapped: "danger",
    },
    warrantyState: {
        not_set: "subtle",
        expired: "danger",
        due_soon: "warning",
        valid: "success",
    },
    maintenanceState: {
        not_set: "subtle",
        overdue: "danger",
        due_soon: "warning",
        normal: "success",
    },
};

const badgeLabels = {
    operationalStatus: equipmentOperationalStatusDisplay,
    warrantyState: equipmentWarrantyStateDisplay,
    maintenanceState: equipmentMaintenanceStateDisplay,
};

const daysSuffix = (kind, value, daysRemaining) => {
    if (kind === "operationalStatus" || daysRemaining === null || daysRemaining === undefined) {
        return "";
    }
    if (value === "not_set") {
        return "";
    }
    const days = Number(daysRemaining);
    if (Number.isNaN(days)) {
        return "";
    }
    return days < 0 ? `（逾期 ${Math.abs(days)} 天）` : `（剩余 ${days} 天）`;
};

/**
 * @param {object} props
 * @param {"operationalStatus"|"warrantyState"|"maintenanceState"} props.kind
 * @param {string} props.value stable code returned by the API
 * @param {number} [props.daysRemaining] negative when overdue/expired
 */
export const EquipmentStatusBadge = ({ kind, value, daysRemaining, size = "medium" }) => {
    if (!value) {
        return <span>-</span>;
    }

    const label = badgeLabels[kind]?.[value] || value;
    const color = badgeColors[kind]?.[value] || "subtle";

    return (
        <FC.Badge appearance="tint" color={color} size={size}>
            {`${label}${daysSuffix(kind, value, daysRemaining)}`}
        </FC.Badge>
    );
};
